import { resolveTenantFromUrl } from '@low6-pickem/frontend-shared';

const API_BASE_URL =
  import.meta.env.VITE_PREPLAY_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:3001';

const TENANT_SLUG = resolveTenantFromUrl();

export interface ClerkSessionResponse {
  token: string;
  user: {
    sso_user_id: string;
    username: string;
    email: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string;
    country?: string;
    state?: string;
  };
}

/**
 * Exchange a Clerk session JWT for the internal application JWT (HS256).
 * Follows the same contract as the OAuth callback response.
 */
export async function exchangeClerkSession(
  clerkSessionToken: string
): Promise<ClerkSessionResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/clerk/session`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${clerkSessionToken}`,
      'Content-Type': 'application/json',
      'X-Tenant-Slug': TENANT_SLUG,
    },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { message?: string; error?: string };
    throw new Error(
      body.message || body.error || `Clerk session exchange failed (${response.status})`
    );
  }

  return response.json() as Promise<ClerkSessionResponse>;
}
